export default __webpack_public_path__ + "static/media/TD.14a88412.svg";